module.exports = __webpack_public_path__ + "static/media/brand-promotion-mobile-gendai.36b44bbf.png";